import React, { Component } from "react";
import {inject, observer} from 'mobx-react';
import { OFFLINE_MODE_ALERT, GraphikFont } from '../../constants';
import megaphoneImg from '../../assets/megaphone.png';

const overlayBackdrop = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255, 255, 255, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 100,
};

const dialogCard = {
    backgroundColor: "#3B3A39",
    padding: "3vh 2.5vw 4.44vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "85%",
    maxWidth: "1089px",
    boxSizing: "border-box",
};

const illustrationStyle = {
    width: "10.42vw",
    maxWidth: "200px",
    height: "auto",
};

const titleStyle = {
    fontFamily: GraphikFont.BOLD,
    fontSize: "2.08vw",
    color: "white",
    textAlign: "center",
    lineHeight: "1",
    marginTop: "1.48vh",
};

const subtitleStyle = {
    fontFamily: GraphikFont.REGULAR,
    fontSize: "1.56vw",
    color: "rgba(255, 255, 255, 0.85)",
    textAlign: "center",
    lineHeight: "1",
    marginTop: "1.48vh",
};

@inject('RootStore')
@observer
export default class OfflineModeOverlay extends Component {
    render() {
        const { configStore } = this.props.RootStore;

        if (!configStore.displayOfflineMode) {
            return null;
        }

        return (
            <div style={overlayBackdrop}>
                <div style={dialogCard}>
                    <img src={megaphoneImg} style={illustrationStyle} alt="" />
                    <div style={titleStyle}>
                        {OFFLINE_MODE_ALERT.title}
                    </div>
                    <div style={subtitleStyle}>
                        {OFFLINE_MODE_ALERT.desc}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/alerts/offline_mode_overlay.jsx